<template>
	<div>
		<div class="d-grid d-sm-flex justify-content-sm-between gap-2 mb-2">
			<router-link :to="{path: '/admin/exams'}" class="btn btn-outline-secondary">{{$t('btn.goto-exams')}}</router-link>
			<form role="form" style="min-width: 50%;" @submit.prevent="page = 1; loadData();">
				<div class="input-group">
					<input type="text" v-model="search" class="form-control" :placeholder="$t('placeholder.search')" />
					<button type="submit" class="btn btn-outline-secondary" :disabled="loading" :content="$t('tooltip.btn.search')" v-tippy="{placement: 'top'}">
						<font-awesome-icon :icon="['fas', loading ? 'spinner' : 'magnifying-glass']" :spin="loading" />
					</button>
				</div>
			</form>
		</div>
		<div class="table-responsive">
			<table class="table table-hover align-middle">
				<thead>
					<tr>
						<th scope="col" width="20">
							<div class="form-check mb-0">
								<input class="form-check-input" type="checkbox" v-model="selectedAllExams" @change="onToggleSelectAllExams()" />
							</div>
						</th>
						<th scope="col" width="100">{{$t('text.date')}}</th>
						<th scope="col" width="20%">{{$t('text.group')}}</th>
						<th scope="col" class="text-center" width="50">{{$t('text.lang')}}</th>
						<th scope="col">{{$t('text.qualifications-disciplines')}}</th>
						<th scope="col" width="10%">{{$t('text.organization-cut')}}</th>
						<th scope="col" class="text-end" width="250">
							<font-awesome-icon :icon="['fas', 'spinner']" spin v-if="loading" />
							<div class="btn-toolbar justify-content-end gap-2" v-if="checkedExams.length > 0 && !loading">
								<div class="btn-group">
									<button type="button" class="btn btn-outline-secondary" @click="onShowMoveFromArchiveMultiModal(checkedExams)" :content="$t('tooltip.btn.move-from-archive-selected')" v-tippy="{placement: 'top'}">
										<font-awesome-icon :icon="['fas', 'box-archive']" />
									</button>
									<button type="button" class="btn btn-outline-danger" @click="onShowDeleteMultiModal(checkedExams)" :content="$t('tooltip.btn.delete-selected')" v-tippy="{placement: 'top'}">
										<font-awesome-icon :icon="['fas', 'trash-can']" />
									</button>
								</div>
							</div>
						</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="exam in exams" :key="exam.id">
						<td>
							<div class="form-check mb-0">
								<input class="form-check-input" type="checkbox" :value="exam.id" v-model="checkedExams" v-if="!exam.started" />
							</div>
						</td>
						<td>{{formatDate(exam.date, 'DD.MM.YYYY')}}</td>
						<td>{{exam.group_name}}</td>
						<td class="text-center">{{exam.lang.toUpperCase()}}</td>
						<td>
							<div v-if="exam.qualification_id">{{exam.qualification_name}}</div>
							<ul class="mb-0" v-if="exam.disciplines.length > 0">
								<li v-for="discipline in exam.disciplines" :key="discipline.id">{{discipline.name}}</li>
							</ul>
							<div class="text-danger" v-else>
								<strong>{{$t('text.danger.disciplines-not-exists')}}</strong>
							</div>
						</td>
						<td>
							<span :content="exam.organization_name" v-tippy="{placement: 'top'}">{{exam.organization_shortname}}</span>
						</td>
						<td>
							<div class="btn-toolbar justify-content-end gap-2">
								<div class="btn-group">
									<a :href="'/api/pdf/report-statement/'+exam.id+'?lang='+appModel.getLang()" target="_blank" class="btn btn-outline-secondary" :content="$t('tooltip.btn.statement')" v-tippy="{placement: 'top'}" v-if="!exam.started && exam.ended">
										<font-awesome-icon :icon="['fas', 'file-contract']" />
									</a>
									<router-link :to="{path: '/admin/exams/'+exam.id+'/students'}" class="btn btn-outline-secondary" :content="$t('tooltip.btn.students')" v-tippy="{placement: 'top'}">
										<font-awesome-icon :icon="['fas', 'users']" />
									</router-link>
								</div>
								<div class="btn-group" v-if="!exam.started">
									<button type="button" class="btn btn-outline-primary" @click="onShowEditModal(exam.id)" :content="$t('tooltip.btn.change')" v-tippy="{placement: 'top'}" v-if="!exam.started && !exam.ended">
										<font-awesome-icon :icon="['fas', 'pencil']" />
									</button>
									<button type="button" class="btn btn-outline-secondary" @click="onShowMoveFromArchiveModal(exam.id)" :content="$t('tooltip.btn.move-from-archive')" v-tippy="{placement: 'top'}">
										<font-awesome-icon :icon="['fas', 'box-archive']" />
									</button>
									<button type="button" class="btn btn-outline-danger" @click="onShowDeleteModal(exam.id)" :content="$t('tooltip.btn.delete')" v-tippy="{placement: 'top'}">
										<font-awesome-icon :icon="['fas', 'trash-can']" />
									</button>
								</div>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div class="text-center mt-2">
			<div class="mb-1">{{$t('text.total-exams-archive')}}: {{exams_count}}</div>
			<nav aria-label="Page navigation">
				<ul class="pagination justify-content-center mb-0">
					<li class="page-item" :class="{'disabled': page == 1}">
						<a class="page-link" href="javascript://" @click="gotoPage(page - 1)" aria-label="Previous">
							<font-awesome-icon :icon="['fas', 'chevron-left']" />
						</a>
					</li>
					<li class="page-item" :class="{'active': page == 1}">
						<a class="page-link" href="javascript://" @click="gotoPage(1)">1</a>
					</li>
					<li class="page-item disabled" v-if="page - paginationAlpha > 2">
						<span class="page-link">...</span>
					</li>
					<li class="page-item" :class="{'active': page == i}" v-for="i in range(paginationA1, paginationA2)" :key="i" v-show="paginationA2 >= paginationA1">
						<a class="page-link" href="javascript://" @click="gotoPage(i)">{{i}}</a>
					</li>
					<li class="page-item disabled" v-if="page + paginationAlpha < getPagesCount() - 1">
						<span class="page-link">...</span>
					</li>
					<li class="page-item" :class="{'active': page == getPagesCount()}" v-if="getPagesCount() > 1">
						<a class="page-link" href="javascript://" @click="gotoPage(getPagesCount())">{{getPagesCount()}}</a>
					</li>
					<li class="page-item" :class="{'disabled': page == getPagesCount() || getPagesCount() == 0}">
						<a class="page-link" href="javascript://" @click="gotoPage(page + 1)" aria-label="Next">
							<font-awesome-icon :icon="['fas', 'chevron-right']" />
						</a>
					</li>
				</ul>
			</nav>
		</div>
	</div>
</template>

<style lang="scss">
      
</style>

<script>
import lib from '@/lib';
import { useMeta } from 'vue-meta';

import ExamEditModal from '@/components/modals/exams/ExamEditModal';
import ExamMoveFromArchiveModal from '@/components/modals/exams/ExamMoveFromArchiveModal';
import ExamMoveFromArchiveMultiModal from '@/components/modals/exams/ExamMoveFromArchiveMultiModal';
import ExamDeleteModal from '@/components/modals/exams/ExamDeleteModal';
import ExamDeleteMultiModal from '@/components/modals/exams/ExamDeleteMultiModal';

export default {
	mixins: lib.mixins,
	setup(){
		useMeta({title: 'Архив экзаменов | KMIB EDU Admin'});
	},
	data: () => ({
		exams: [],
		exams_count: 0,
		
		selectedAllExams: false,
		checkedExams: [],
		
		search: '',
		page: 1,
		limit: 25,
		loading: true,
		error: '',
		
		paginationAlpha: 3,
	}),
	computed: {
		paginationA1(){
			return Math.max(this.page - this.paginationAlpha, 2);
		},
		paginationA2(){
			return Math.min(this.page + this.paginationAlpha, this.getPagesCount() - 1);
		},
	},
	watch: {
		exams(){
			this.selectedAllExams = false;
			this.checkedExams = [];
		},
		checkedExams(val){
			this.selectedAllExams = val.length == this.exams.length;
		},
	},
	methods: {
		range: lib.range,
		formatDate: lib.formatDate,
		
		onToggleSelectAllExams(){
			if(this.selectedAllExams){
				this.checkedExams = this.exams.map((el) => el.id);
			} else {
				this.checkedExams = [];
			}
		},
		
		onShowEditModal(id){
			let that = this;
			this.$vfm.show({
				component: ExamEditModal,
				bind: {
					styles: {
						display: 'block',
					},
				},
				on: {
					edit(close){
						that.loadData();
						close();
					},
					cancel(close){
						close();
					},
				},
				params: {
					exam: this.exams.find((el) => el.id == id),
				},
			});
		},
		onShowMoveFromArchiveModal(id){
			let that = this;
			this.$vfm.show({
				component: ExamMoveFromArchiveModal,
				bind: {
					styles: {
						display: 'block',
					},
				},
				on: {
					moveFromArchive(close){
						that.loadData();
						close();
					},
					cancel(close){
						close();
					},
				},
				params: {
					exam: this.exams.find((el) => el.id == id),
				},
			});
		},
		onShowMoveFromArchiveMultiModal(ids){
			let that = this;
			this.$vfm.show({
				component: ExamMoveFromArchiveMultiModal,
				bind: {
					styles: {
						display: 'block',
					},
				},
				on: {
					moveFromArchiveMulti(close){
						that.loadData();
						close();
					},
					cancel(close){
						close();
					},
				},
				params: {
					ids,
				},
			});
		},
		onShowDeleteModal(id){
			let that = this;
			this.$vfm.show({
				component: ExamDeleteModal,
				bind: {
					styles: {
						display: 'block',
					},
				},
				on: {
					delete(close){
						that.loadData();
						close();
					},
					cancel(close){
						close();
					},
				},
				params: {
					exam: this.exams.find((el) => el.id == id),
				},
			});
		},
		onShowDeleteMultiModal(ids){
			let that = this;
			this.$vfm.show({
				component: ExamDeleteMultiModal,
				bind: {
					styles: {
						display: 'block',
					},
				},
				on: {
					deleteMulti(close){
						that.loadData();
						close();
					},
					cancel(close){
						close();
					},
				},
				params: {
					ids,
				},
			});
		},
		
		async loadData(){
			this.loading = true;
			this.error = '';
			this.$router.push({query: Object.assign({}, this.$route.query, {
				search: this.search,
				page: this.page,
			})});
			const params = {
				search: this.search,
				start: (this.page - 1) * this.limit,
				limit: this.limit,
			};
			const ret = await this.appModel.doGetExamsArchive(params);
			if(ret.success){
				this.exams = ret.list;
				this.exams_count = ret.count;
			} else {
				this.error = ret.message;
			}
			this.loading = false;
		},
		
		gotoPage(page){
			if(page >= 1 && page <= this.getPagesCount() && page != this.page){
				this.page = page;
				this.loadData();
				window.scrollTo(0, 0);
			}
		},
		// получение количества страниц
		getPagesCount(){
			return Math.ceil(this.exams_count / this.limit);
		},
	},
	async mounted(){
		this.appModel.pageTitle = 'title.exams.archive';
		
		if(this.$route.query.search) this.search = this.$route.query.search;
		if(this.$route.query.page) this.page = parseInt(this.$route.query.page || 1);
		
		await this.loadData();
		
		window.scrollTo(0, 0);
	},
	beforeMount(){
		if(this.authModel.isAuth()){
			if(this.authModel.isEditor()){
				this.$router.push({path: '/editor'});
			} else if(this.authModel.isStudent()){
				this.$router.push({path: '/'});
			}
		}
	},
	beforeRouteUpdate(to, from, next){
		//window.scrollTo(0, 0);
		next();
	},
};
</script>